// JsFromRoutes CacheKey 6047d44b0e90b6d0527d62c5e6d37b62
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/:venue_slug/statistics/kitchen_production'),
}
